<!--
  smooth-eのトップ画面
  外部からのリダイレクトの1次受付画面でもある
-->
<template>
  <div
    class="d-flex flex-column justify-center align-center"
    style="height: 100vh"
  >
    <v-img
      src="/resources/landing/smooth-e_white_logo_tate.png"
      width="287px"
      :max-height="228"
    />
    <sm-btn-outlined
      text="ログイン"
      color="white"
      class="mt-4"
      @click-btn="goToLogin"
    />
    <div class="mt-16">
      <sm-list-icon
        style="color: white;"
        left-icon="$description_outlined"
        left-icon-color="white"
        text="初回登録の詳細な手順"
        text-color="white"
        right-icon="$chevron_right_round"
        right-icon-color="white"
        @click="goToInitialRegistrationManual"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { defineAsyncComponent, PropType } from 'vue'
import { staticRoutes } from '@/routes'
import { nativeBridge } from '@/libs/native-bridge'
import { windowOpen } from '@/libs/window-open'
import { myDeviceModule } from '@/stores/my-device-store'

// 遷移可能先の集合
// まずは目的に応じた画面に遷移させ、そこでログイン処理やさらに特定の画面への遷移などを実施する
const TRANSITION_TO = {
  [staticRoutes.loginCompletion.path]: staticRoutes.loginCompletion.name,
  [staticRoutes.externalLogin.path]: staticRoutes.externalLogin.name,
  [staticRoutes.externalLoginCompletion.path]: staticRoutes.externalLoginCompletion.name,
  [staticRoutes.logoutCompletion.path]: staticRoutes.logoutCompletion.name,
} as const

@Component({
  components: {
    SmBtnOutlined: defineAsyncComponent(() => import('@/components/atoms/SmBtnOutlined.vue')),
    SmText: defineAsyncComponent(() => import('@/components/atoms/SmText.vue')),
    SmListIcon: defineAsyncComponent(() => import('@/components/molecules/SmListIcon.vue')),
  }
})
export default class LandingPage extends Vue {
  /**
   * 外部から直接特定のページに遷移したい際に指定される想定（メールやプッシュ通知、素敵ネットとのSSO連携）。
   * vue-routerの機能でクエリパラメータをredirect, additionalParamsの2つのpropにマップしている。
   */
  @Prop({ type: String })
  redirect?: string

  @Prop({ type: Object as PropType<Record<string, string>> })
  additionalParams?: Record<string, string>

  beforeCreate(): void {
    if (nativeBridge.isNativeApp) {
      // デバイストークンをネイティブから受け入れる準備をしてから、ネイティブにトークンの連携を要求する
      nativeBridge.register('registerDeviceToken', token => myDeviceModule.setDeviceToken(token))
      nativeBridge.callNative('onDeviceTokenRequested')
    }
  }

  created(): void {
    let redirect = this.redirect
    let additional = this.additionalParams

    if (!redirect) return

    if (redirect.includes('?error=')) { // see: https://bitbucket.org/fit_smooth-e/smooth-e.web.owner/pull-requests/272
      const sp = redirect.split('?error=')
      redirect = sp[0]
      additional = { error: sp[1] }
    }

    if (redirect in TRANSITION_TO) {
      this.$router.push({ name: TRANSITION_TO[redirect], query: additional })
    }
  }

  goToLogin():void {
    this.$router.push({ name: staticRoutes.login.name })
  }

  goToInitialRegistrationManual(): void {
    windowOpen('/static-assets/initial-registration-manual')
  }
}
</script>
